/*
 * Juno Collection Hover Video
 * Handles autoplay on hover for collection grid items with video secondary media
 */
document.addEventListener('DOMContentLoaded', function () {
    const gridItems = document.querySelectorAll('.grid-product');

    gridItems.forEach(item => {
        // Check if item has a hover video
        const video = item.querySelector('.js-hover-video');

        if (video) {
            item.addEventListener('mouseenter', function () {
                const playPromise = video.play();

                if (playPromise !== undefined) {
                    playPromise.then(_ => {
                        // Automatic playback started!
                    })
                        .catch(error => {
                            console.log('Autoplay prevented by browser policy or error:', error);
                        });
                }
            });

            item.addEventListener('mouseleave', function () {
                video.pause();
                video.currentTime = 0; // Reset to start
            });
        }
    });
});
